import styled from "styled-components";
export default styled.div.withConfig({
  displayName: "View",
  componentId: "sc-f6ce3k-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
    scrollY = _ref.scrollY,
    maxHeight = _ref.maxHeight;
  return "\n    display: ".concat(scrollY ? "block" : "flex", ";\n    overflow-y: ").concat(scrollY ? "auto" : "hidden", ";\n    flex: ").concat(!scrollY ? 1 : "", ";\n    background: ").concat(theme.colors.G3, ";\n    height: ").concat(maxHeight ? "calc(100vh - 54px)" : "", ";\n\n    ").concat(!scrollY ? "\n      @media (max-width: ".concat(theme.breakpoints[2], "){\n        display: block;\n        overflow-y: auto;\n      }\n    ") : "", "\n\n    @media (max-width: ").concat(theme.breakpoints[1], "){\n      padding: 0;\n    }");
});